import { IconButton, InputAdornment, TextField, Tooltip, useTheme } from "@mui/material";
import { QrCodeReaderModal } from "./qr-code-reader.js";
import { QrCodeScanner } from "@mui/icons-material";
import { SupportContext } from "./provider.js";
import { useMediaQuery } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import Cleave from "cleave.js/react";
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
export const isCodeThirdVersion = (code) => {
    if ((process.env.NEXT_PUBLIC_LNG ?? "") === "ru")
        return true;
    if (code.length < 4)
        return false;
    if (!code.startsWith("CM"))
        return false;
    const cleanedCode = code.trim().replaceAll("–", "").replaceAll("-", "");
    return cleanedCode.length === 20 && /^[A-Z2-9]+$/.test(cleanedCode);
};
const assignRefs = (...refs) => {
    return (node) => {
        refs.forEach((r) => {
            if (typeof r === "function") {
                r(node);
            }
            else if (r) {
                r.current = node;
            }
        });
    };
};
const InputMask = React.forwardRef(({ styleProps, ...props }, ref) => {
    const theme = useTheme();
    const isThirdVersion = isCodeThirdVersion(props.value);
    const localRef = React.useRef(null);
    React.useEffect(() => {
        localRef?.current?.focus();
    }, [isThirdVersion]);
    return (React.createElement(Cleave, { "data-testid": "access-code-input", htmlRef: assignRefs(localRef, ref), key: isThirdVersion ? "isThirdVersion.true" : "isThirdVersion.false", options: {
            blocks: isThirdVersion ? [4, 4, 4, 4, 4] : [],
            copyDelimiter: isThirdVersion,
            delimiter: isThirdVersion ? "–" : "",
            delimiterLazyShow: false,
            initValue: isThirdVersion ? "XXXX-XXXX-XXXX-XXXX-XXXX" : "",
            uppercase: isThirdVersion,
        }, style: { width: "100%", padding: `${theme.spacing(2)} ${theme.spacing(2)}` }, ...props }));
});
InputMask.displayName = "Mask";
export const AccessCodeInput = ({ onChange, value }) => {
    const isTouchDevice = useMediaQuery("(hover: none)");
    const { t } = useTranslation("c-support");
    const { enableQrScanner, isLoading } = React.useContext(SupportContext);
    const wrapWithTooltip = (n, title, key) => isTouchDevice ? (n) : (React.createElement(Tooltip, { arrow: true, title: title, key: key }, n));
    const openQrCodeScanner = () => {
        if (!enableQrScanner)
            return;
        NiceModal.show(QrCodeReaderModal);
    };
    const handleChange = (e) => {
        const value = e.target.rawValue ?? "";
        const isThirdVersion = isCodeThirdVersion(value);
        const sanitized = isThirdVersion
            ? String(value).trim().replaceAll("–", "").replaceAll("-", "")
            : String(value).trim();
        onChange && onChange(sanitized);
    };
    const Icon = wrapWithTooltip(React.createElement(IconButton, { "aria-label": t("qr-code-btn-label", "QR Code scannen"), "data-testid": "open-qr-code-scanner", edge: "end", onClick: openQrCodeScanner, size: "large", style: { color: "inherit", marginRight: 0 } },
        React.createElement(QrCodeScanner, null)), t("qr-code-btn-label"));
    return (React.createElement(TextField, { disabled: isLoading, fullWidth: true, name: "access-code", onChange: handleChange, InputProps: {
            endAdornment: enableQrScanner ? React.createElement(InputAdornment, { position: "end" }, Icon) : null,
            inputComponent: InputMask,
            sx: { fontSize: { xs: "1.15rem", md: "1.375rem" } },
        }, placeholder: t("access-code-input-placeholder", "Bitte gib deinen Zugangscode ein."), value: value, variant: "filled" }));
};
//# sourceMappingURL=access-code-input.js.map